const SkeletonLine = ({
  width = "100%",
  animation,
  height = "100%",
  color = "#e5e7eb",
  radius = "4px",
  className = "",
  style = {},
}) => {
  return (
    <div
      className={`${className} ${
        animation === false
          ? ""
          : animation === "pulse"
          ? "animate-pulse"
          : "animate-wave"
      }`}
      style={{
        width,
        borderRadius: radius,
        height,
        background: color,
        ...style,
      }}
    />
  );
};
export default SkeletonLine;
